/**
 * Renderização HTML do módulo Formulário Simples
 */

import { escapeHtml } from '../helpers/formularioSimplesHelpers.js';

export function buildFormularioSimplesHTML(config, data) {
    const { cssPrefix } = config;

    const optionsHtml = data.selectOptions
        .map((option) => `<option value="${escapeHtml(option.value)}">${escapeHtml(option.label)}</option>`)
        .join('');

    return `
        <div class="${cssPrefix}-wrapper">
            <div class="${cssPrefix}-card">
                <h3 class="${cssPrefix}-title">${escapeHtml(data.title)}</h3>
                ${data.description ? `<p class="${cssPrefix}-description">${escapeHtml(data.description)}</p>` : ''}

                <form class="${cssPrefix}-form" id="${cssPrefix}-form" novalidate>
                    <div class="${cssPrefix}-field-group">
                        <input
                            type="email"
                            id="${cssPrefix}-email"
                            name="email"
                            placeholder="${escapeHtml(data.emailPlaceholder)}"
                            autocomplete="email"
                            required
                        />
                        <div id="${cssPrefix}-email-error" class="${cssPrefix}-error"></div>
                    </div>

                    <div class="${cssPrefix}-field-group">
                        ${data.selectLabel ? `<label for="${cssPrefix}-select">${escapeHtml(data.selectLabel)}</label>` : ''}
                        <select id="${cssPrefix}-select" name="${escapeHtml(data.selectName)}" required>
                            <option value="">${escapeHtml(data.selectPlaceholder)}</option>
                            ${optionsHtml}
                        </select>
                        <div id="${cssPrefix}-select-error" class="${cssPrefix}-error"></div>
                    </div>

                    <div class="${cssPrefix}-field-group ${cssPrefix}-submit-group">
                        <button type="submit" class="${cssPrefix}-submit" disabled>${escapeHtml(data.ctaText)}</button>
                        <div class="${cssPrefix}-error ${cssPrefix}-submit-spacer" aria-hidden="true"></div>
                    </div>
                </form>

                <div class="${cssPrefix}-message" id="${cssPrefix}-message"></div>
            </div>
        </div>
    `;
}
